import React, { useState } from "react";
import { Spinner } from "../../assets";
import { useSelector } from "react-redux";
import { API_ROOT } from "../../constants";
import { errorResponse } from "../../helpers";
import axios from "axios";

export default function StripeDashboardButton({ handlerUrl }) {

	const token = useSelector(state => state.session.token);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	return <>
		<button
			className="stripeButton"
			onClick={e => {
				setLoading(true);
				setError(null);
				getStripeLink(token, handlerUrl).then(link => {
					setLoading(false);
					window.open(link, "_blank");
				}).catch(error => {
					setError(error);
					setLoading(false);
				});
			}}
			style={loading ?
				{
					height: 44,
					padding: 10,
					cursor: "default"
				} : {
					cursor: "pointer"
				}
			}
		>
			{loading ? <Spinner /> : "Go to dashboard"}
		</button>
		{error && <div className="error text-center">{error}</div>}
	</>
}

function getStripeLink(token, url) {
	return new Promise((resolve, reject) => {
		axios.get(`${API_ROOT}${url}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
			.then(res => res.data)
			.then(resolve)
			.catch(error => reject(errorResponse(error)));
	});
}